  <div *ngIf="(this.mls.featureOnOffList.moduleList.POST.value || !mls.userLoginFlow)">
  <div class="custom-theme-modal modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable" role="document">
    <div class="modal-content create-post-modal">
      <div class="modal-header d-block py-3 border-color">
        <div class="row">
          <div class="col-5 pr-0 d-flex align-items-center">
            <h6 class="heading-4">
              <span class="cursor-pointer" 
                 (click)="closePostModal()">
                <img class="pb-1" src="assets/themes/icons/cancel.svg" alt="cross">
              </span>
              <span *ngIf="this.show_poll==false" class="ml-2 color-grey-700">{{mls.languageText.create_posting.key1}}<span
                  *ngIf="mls?.is_lskey_display==1">(create_posting.key1)</span></span>
              <span *ngIf="this.show_poll==true" class="ml-2 color-grey-700">{{mls.languageText.create_posting.key6}}<span
                  *ngIf="mls?.is_lskey_display==1">(create_posting.key6)</span></span>
            </h6>
          </div>

          <div class="col-7 pl-0 text-right">
            <button (click)="openDraftList()" 
              *ngIf="dss.postDraftData.length>0" type="button"
              class="btn-design outline medium w-25 mr-2">
              {{mls.languageText.create_posting.key11}}
              <span *ngIf="mls?.is_lskey_display==1">(create_posting.key11)</span>
            </button>
            <!-- communitypost emit 2 -->
            <button *ngIf="dss.nextButtonEnabled && dss.calling_from_community == 1  && dss.topic_community_flag == 1"
              (click)="nextPostScreen.emit(5);isDraftPost()"
              type="button" [disabled]="showColor==false" [ngClass]=" showColor ? 'filled' : 'filled-disabled'"
              class="btn-design medium w-25 position-relative ml-2">
              {{mls.languageText.create_posting.key14}}
              <span *ngIf="mls?.is_lskey_display==1">(create_posting.key14)</span>
            </button>

            <button *ngIf="dss.nextButtonEnabled && dss.topic_community_flag != 1"
              (click)="nextPostScreen.emit(2);isDraftPost()"
              type="button" [disabled]="showColor==false" [ngClass]=" showColor ? 'filled' : 'filled-disabled'"
              class="btn-design medium w-25 position-relative ml-2">
              {{mls.languageText.create_posting.key14}}
              <span *ngIf="mls?.is_lskey_display==1">(create_posting.key14)</span>
            </button>


            <button *ngIf="!dss.nextButtonEnabled" [disabled]="showColor==false" [ngClass]=" showColor  ? 'filled' : 'filled-disabled'"  type="button" class="btn-design  medium position-relative"  (click)="fileUploadingProcess()">
              {{mls.languageText.create_post_association.key2}}
            </button>
          </div>
        </div>
      </div>
      <div class="modal-body pt-2 pb-4 create-post-modal-body">
        <div ngbDropdown class="profile-post-container p-2 mb-3 position-relative">
          <div class="cursor-pointer d-flex align-items-center justify-content-between" ngbDropdownToggle *ngIf="dss.posting_data.screen1.is_anonymous==0">
            <div class="d-flex align-items-center">
            <div class="pr-0 profile-post-pic-box">
              <div class="user-56">
                <div class="position-relative">
                  <app-user-pofile-pic [profile_pic_image]="create_post_image"></app-user-pofile-pic>
                </div>
              </div>
            </div>
            <div class="pr-0 cursor-pointer profile-post-pic-container">
              <div>
                <p class="secondary-paragraph text-truncate">
                  <span class="color-grey-500">{{mls.languageText.create_posting.key2}}
                    <span *ngIf="mls?.is_lskey_display==1">(create_posting.key2)</span></span><br />
                  <span class="paragraph-bold ">
                    {{profile_data?.profile?.first_name}} {{profile_data?.profile?.middle_name}} {{profile_data?.profile?.last_name}}
                  </span>
                </p>
              </div>
            </div>
            </div>
            <div>
            <img class="ml-4" src="assets/themes/icons/down-arrow.svg" alt="down">
          </div>
          </div>
          <app-custom-tooltip class="max-width-tooltip" *ngIf="tooltip_data?.length>0" [tooltip_data]="tooltip_data"
           [view_identifier]="'POSTING_BY_VIEW'" [position]="'bottom'"></app-custom-tooltip>


          <div class="cursor-pointer d-flex align-items-center justify-content-between" ngbDropdownToggle *ngIf="dss.posting_data.screen1.is_anonymous==1">
            <div class="d-flex align-items-center">
              <div class="pr-0 profile-post-pic-box">
                <div class="user-56">
                  <div class="position-relative">
                    <img src="assets/themes/icons/user-profile-red-placeholder.svg" alt="annonymous">
                  </div>
                </div>
              </div>
              <div class="pr-0 cursor-pointer profile-post-pic-container">
                <p class="secondary-paragraph"><span
                    class="color-grey-500">{{mls.languageText.create_posting.key2}}<span
                      *ngIf="mls?.is_lskey_display==1">(create_posting.key2)</span></span><br />
                  <span class="paragraph-bold">
                    {{mls.languageText.create_posting.key13}}
                    <span *ngIf="mls?.is_lskey_display==1">(create_posting.key13)</span>
                  </span>
                </p>
              </div>
            </div>
            <div>
              <img src="assets/themes/icons/down-arrow.svg" class="ml-4" alt="down">
            </div>
          </div>

          <div ngbDropdownMenu aria-labelledby="dropdownBasic1" class="custom-dropdown profile-post-dropdown-list p-0 border-0">
            <ul class="overflow-hidden">
              <li (click)="is_anonymous(0)" ngbDropdownItem>
                <label class="d-block cursor-pointer clearfix mb-0">
                  <div class="d-flex align-items-center justify-content-between">
                    <div class="d-flex align-items-center">
                    <div class="pr-0 box-56">
                      <div class="position-relative user-56">
                        <app-user-pofile-pic [profile_pic_image]="create_post_image"></app-user-pofile-pic>
                      </div>
                    </div>

                    <div class="pl-3 pr-0 profile-post-dropdown-list-content">
                      <div>
                        <div>
                          <div>
                            <p class="secondary-paragraph-bold text-truncate">
                              <span>{{profile_data?.profile?.first_name}}
                                {{profile_data?.profile?.middle_name}} {{profile_data?.profile?.last_name}} </span>
                              <br />
                              <span class="color-grey-500" *ngFor="let spe of profile_data?.speciality">
                                <span title={{spe?.speciality_name}}>{{(spe?.is_primary==1)? spe?.speciality_name:''}}</span>

                              </span>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    </div>
                    <div class="mb-4">
                      <label class="radio">
                        <input type="radio" name="post" [checked]="dss.posting_data.screen1.is_anonymous==0" />
                        <span></span>
                      </label>
                    </div>
                  </div>
                </label>
              </li>
              <!--  -->
              <li (click)="is_anonymous(1)" ngbDropdownItem>
                <label class="d-block cursor-pointer clearfix mb-0">
                  <div class="d-flex align-items-center justify-content-between">
                  <div class="d-flex align-items-center">
                    <div class="pr-0 user-56">
                      <div class="position-relative user-56">
                        <img src="assets/themes/icons/user-profile-red-placeholder.svg" alt="annonymous">

                      </div>
                    </div>
                    <div class="pl-3 profile-post-dropdown-list-content">
                      <div>
                        <div>
                          <p class="secondary-paragraph-bold text-truncate">
                            <span>{{mls.languageText.create_posting.key13}}<span
                                *ngIf="mls?.is_lskey_display==1">(create_posting.key13)</span></span><br />
                            <span *ngFor="let spe of profile_data?.speciality">
                             <span class="color-grey-500">
                              <span title={{spe?.speciality_name}}>{{(spe?.is_primary==1)? spe?.speciality_name:''}}</span>
                             </span>
                            </span>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="mb-4">
                    <label class="radio">
                      <input type="radio" [checked]="dss.posting_data.screen1.is_anonymous==1" name="post"/>
                      <span></span>
                    </label>
                  </div>
                  </div>
                </label>
              </li>
            </ul>
          </div>
        </div>


        <label *ngIf="max_media_err.length > 0" class="primary-small">
          <small *ngFor="let msg of max_media_err" class="color-error">
            {{msg}}<br />
          </small>
        </label>
        <div class="form-textarea position-relative">
          <div class="textarea-field p-0">
          <span *ngIf="meta_api_in_process==true" class="spinner-border spinner-border-sm position-absolute" role="status" aria-hidden="true" style="right: 0;"></span>

          <textarea
            [ngClass]="{'repost-post-textarea':dss.isRepostStatus === numbers.TWO, 'post-textarea-field' : dss.isRepostStatus !== numbers.TWO }"
            class="textarea-field border-0"
            (paste)="onPaste($event)"
            [(ngModel)]="dss.posting_data.screen1.content"
            #content='ngModel'
            (keyup.enter)="onPaste($event)"
            (keyup)="validateInput($event)"
            placeholder="{{content_paceholder}}">{{dss.posting_data.screen1.content}}</textarea>

          <div class="postbox mx-3 mb-2 secondary-paragraph repost_disabled"
            *ngIf="repostedData && dss.repostProductType === productTypeConstant.WEBINAR">
            <div class="p-2">
              <app-webinar-card
                appear
                [callingfrom]="callingfrom"
                [docCardObj]='repostedData'
                [docTalkSection]=''
                [listLength]="numbers.ONE">
              </app-webinar-card>
            </div>
          </div>

          <div class="postbox mx-3 mb-2 secondary-paragraph repost_disabled"
          *ngIf="repostedData && dss.repostProductType === productTypeConstant.DOCTALKS">
            <div class="p-2">
              <app-web-doctalk-card
                appear
                [callingfrom]="callingfrom"
                [docCardObj]='repostedData'
                [docTalkSection]='"features_videos"'
                [listLength]=2>
              </app-web-doctalk-card>
            </div>
          </div>

          <div class="postbox mx-3 mb-2 secondary-paragraph repost_disabled"
          *ngIf="repostedData && dss.repostProductType === productTypeConstant.ARTICLE">
            <div class="p-2">
              <app-clinical-resource-card
                  appear
                  [callingfrom]="callingfrom"
                  [clinicalObj]="repostedData"
                  [idx]="0"
                 >
              </app-clinical-resource-card>
            </div>
          </div>

          <div class="postbox mx-3 mb-2 secondary-paragraph repost_disabled"
            *ngIf="repostedData && dss.repostProductType === productTypeConstant.FEED">
            <app-feed-card
              appear
              [callingfrom]="callingfrom"
              [feedObj]="repostedData"
              [source]="numbers.ONE"
              [ptoductType]="numbers.ONE"
              [feedIdx]="numbers.ONE"
              [textHeighlight]=""
              [flags]="numbers.ONE">
            </app-feed-card>
          </div>

          <div *ngIf="dss.posting_data.screen1.metaData!=undefined && dss.posting_data.screen1.metaData!='' "
            class="post-card p-3 m-3 w-75 position-relative">
            <!-- meta close -->
            <span (click)="cancelMeta()">
              <img class="meta-icon cursor-pointer" src="assets/themes/icons/gallery-close-icon.svg" alt="cross">
            </span>

            <div *ngIf="dss.posting_data.screen1.metaData.rawmeta!=undefined" class="d-flex flex-column meta-container">
              <div class="d-flex justify-content-center img-container">
                <img *ngIf="dss.posting_data.screen1.metaData.rawmeta.images!=false"
                  src="{{dss.posting_data.screen1.metaData.rawmeta.images}}">
              </div>
              <div class="bg-blue-100">
                <ng-container *ngIf="dss.posting_data.screen1.metaData.rawmeta.title; else canonicalName">
                  <h3 class="meta-title heading-3" 
                    innerHtml="{{dss.posting_data.screen1.metaData.rawmeta.title}}">
                  </h3>
                </ng-container>
                <ng-template #canonicalName>
                  <span class="d-block">{{fcs.extractCanonicalUrl(dss.posting_data.screen1.metaData.rawmeta.canonicalUrl)}}</span>
                </ng-template>
                <h6 class="meta-description secondary-paragraph" 
                  *ngIf="dss.posting_data.screen1.metaData.rawmeta.description; "
                  innerHtml="{{dss.posting_data.screen1.metaData.rawmeta.description}}">
                </h6>
              </div>
              <p class="link-text">
                <a innerHtml="{{dss.posting_data.screen1.metaData.rawmeta.canonicalUrl}}"></a>
              </p>
            </div>

            <div *ngIf="dss.posting_data.screen1.metaData.rawmeta==undefined">
              <img *ngIf="dss.posting_data.screen1.metaData.images!=false"
                src="{{dss.posting_data.screen1.metaData.images}}">
              <h5 class="heading-3" innerHtml="{{dss.posting_data.screen1.metaData.title}}"></h5>
              <p class="paragraph" innerHtml="{{dss.posting_data.screen1.metaData.canonicalUrl}}"></p>
            </div>
          </div>

          <!-- poll option -->
          <div class="post-card p-2 mx-3 mb-3 " *ngIf="dss.posting_data.screen1.feed_kind=='poll' ">
            <div  class="form-input mb-3" *ngFor="let poll of dss.posting_data.screen1.poll; let pollIdx=index">
              <input [(ngModel)]="dss.posting_data.screen1.poll[pollIdx].value" *ngIf="pollIdx<2"
                maxlength="{{PollQuestiontextLimit}}" (keyup)="validateFromPoll($event, pollIdx)" type="text"
                class="input-field w-100"
                placeholder="{{mls.languageText.create_posting.key9}} {{pollIdx+1}}" />
              <div class="row mb-1" *ngIf="pollIdx > 1">
                <div class="col-10 pr-0 form-input">
                  <input [(ngModel)]="dss.posting_data.screen1.poll[pollIdx].value"
                    maxlength="{{PollQuestiontextLimit}}" (keyup)="validateFromPoll($event, pollIdx)" type="text"
                    class="input-field w-100"
                    placeholder="{{mls.languageText.create_posting.key9}} {{pollIdx+1}} {{mls.languageText.create_posting.key15}}" />
                </div>
                <div class="col-2 text-center pt-2">
                  <img class="cursor-pointer"
                    src="assets/themes/icons/trash.svg" alt="bin"
                    (click)="removePoll(pollIdx)" />
                </div>
              </div>

            </div>

            <!--add option  -->
            <button *ngIf="this.dss.posting_data.screen1.poll.length<5"
              (click)="addPoll()" type="button"
              class="btn-design outline medium">
              <svg id="Layer_1" width="10px" data-name="Layer 1" viewBox="0 0 16 16">
                <defs>
                  <style>
                    .add-option {
                      fill: none;
                      stroke: var(--black-color);
                      stroke-linecap: round;
                      stroke-linejoin: round;
                      stroke-width: 1.5px;
                    }
                  </style>
                </defs>
                <title>add</title>
                <line class="add-option" x1="2" y1="8" x2="14" y2="8" />
                <line class="add-option" x1="8" y1="2" x2="8" y2="14" />
              </svg>
              {{mls.languageText.create_posting.key10}}
              <span *ngIf="mls?.is_lskey_display==1">(create_posting.key10)</span>
            </button>
          </div>


          <!-- tag people -->
          <p class="m-3" *ngIf="dss.posting_data && dss.posting_data.screen1 && dss.posting_data.screen1.tag_to.length">
            <span class="secondary-paragraph-bold mr-2 mb-1" *ngFor="let tagedIn of dss.posting_data.screen1.tag_to">
              <span class="cursor-pointer color-blue" *ngIf="tagedIn"
                (click)=navigatetoprofile(tagedIn?.custom_id)>@{{tagedIn?.full_name}}
              </span>
            </span>
          </p>

          <div class="clearfix m-3">
            <div class="mt-2" *ngFor='let urls of dss.temp_post_media; let idx=index'>
              <div class="post-card post-thumbnail-preview mr-3 float-left mb-1 position-relative" id="pdfsrc1">
                <span *ngIf="dss.isRepostStatus !== repostStatus.TWO" (click)="removeMedia(idx)">
                  <img class="meta-icon cursor-pointer" src="assets/themes/icons/gallery-close-icon.svg" alt="cross">
                </span>

                <img *ngIf="urls?.media_type=='video'" class="icon-thumbnail" src="assets/themes/icons/play-icon.svg" width="55" height="55">

                <img *ngIf="urls?.media_type=='document'" (click)="viewpdf(idx)" class="icon-thumbnail cursor-pointer" src="assets/images/grandround/pdf.svg" width="55" height="55">

                <img class="upload-doc" [src]="urls?.local " (click)="openPostMediaModal(idx,urls)" width="145" height="145"/>
              </div>
            </div>
            <img *ngIf="dss.isRepostStatus=== repostStatus.TWO && dss.repostType === exploreSection.CME && dss.certificateUrl === '' " class="upload-doc" [src]= dss.defaultRepost  width="145" height="145"/>
          </div>
        </div>
      </div>
      </div>



      <canvas id="mycanvas" class="d-none"></canvas>

      <div class="modal-footer create-post-modal-footer d-block py-1 pl-3 border-top">
        <ul class="d-flex flex-wrap create-post-modal-container" [ngClass]="{'w-100': fcs.device_detail.is_mobile}">
          <li class="d-table-cell align-top text-center ">
            <input type='file'
              accept="image/png,image/webp, image/jpeg, video/m4v,video/quicktime, video/mp4,video/mpeg,video/x-matroska, video/mpg, video/3gp, video/3gpp, video/mkv, video/mov"
              (click)="openGallery()" class="d-none" id="non-pdf" (change)="onSelectFile($event)"
              multiple>
            <label
              [ngClass]="{'disabled-opacity':(dss.posting_data.screen1.feed_kind=='poll' || dss.isRepostStatus=== repostStatus.TWO)  || dss.temp_post_media.length==media_limit || metaData!=''}"
              for="{{(dss.posting_data.screen1.feed_kind!='poll'  && dss.temp_post_media.length!=media_limit)? 'non-pdf' : ''}}"
              class="button create-post-option-container cursor-pointer m-0 text-truncate mb-0 p-2">
              <img class="mb-2" src="assets/themes/icons/gallery.svg" alt="gallery">
              <br />
              {{mls.languageText.create_posting.key4}}
              <span *ngIf="mls?.is_lskey_display==1">(create_posting.key4)</span>
            </label>
          </li>

          <li class="d-table-cell align-top text-center">
            <input  (click)="openDocument()" type='file' accept="application/pdf" class="d-none"
              id="pdf" (change)="onSelectFile($event)" multiple>

            <label
              [ngClass]="{'disabled-opacity':(dss.posting_data.screen1.feed_kind=='poll' || dss.isRepostStatus=== repostStatus.TWO) || dss.temp_post_media.length==media_limit || metaData!=''}"
              for="{{(dss.posting_data.screen1.feed_kind!='poll'  && dss.temp_post_media.length!=media_limit)? 'pdf' : ''}}"
              class="button create-post-option-container cursor-pointer m-0 text-truncate mb-0 mx-md-3 p-2">
              <img class="mb-2" src="assets/themes/icons/doc.svg" alt="doc">
              <br />
              {{mls.languageText.create_posting.key7}}
              <span *ngIf="mls?.is_lskey_display==1">(create_posting.key7)</span>
            </label>
            <!-- tooltip -->
            <app-custom-tooltip *ngIf="tooltip_data?.length>0" [tooltip_data]="tooltip_data"
              [view_identifier]="'POSTING_TAG'" [position]="'left'"></app-custom-tooltip>
          </li>

          <li class="d-table-cell align-top text-center">
            <label (click)="tagPeople()" class="button create-post-option-container cursor-pointer m-0 text-truncate mb-0 mr-md-3 p-2"
              >
              <img class="mb-2" src="assets/themes/icons/tag.svg" alt="tag">
              <br /> {{mls.languageText.create_posting.key5}}<span
                *ngIf="mls?.is_lskey_display==1">(create_posting.key5)</span>
            </label>
          </li>
          <li (click)="showPoll()" class="d-table-cell align-top text-center">
            <label [ngClass]="{'disabled-opacity':(dss.posting_data.screen1.feed_kind=='poll'  || dss.isRepostStatus=== repostStatus.TWO)}"
              class="button create-post-option-container cursor-pointer m-0 text-truncate mb-0 p-2">
              <img class="mb-2" src="assets/themes/icons/poll.svg" alt="poll">
              <br /> {{mls.languageText.create_posting.key6}}
              <span *ngIf="mls?.is_lskey_display==1">(create_posting.key6)</span>
            </label>
          </li>
        </ul>
      </div>
      <div *ngIf="!dss.nextButtonEnabled" class="border-top">
        <div [class] = "showColor === true ? 'modal-footer d-block pt-3 pb-3 primary-small' : 'modal-footer d-block pt-3 pb-3 primary-small speciality_disabled' "
            [disabled]="showColor === false" [ngClass]=" showColor ? 'primary cursor-pointer' : 'disabled-opacity'"  (click)="openspecialitySelectionList()" >
          <img [src]="'assets/images/setting-icon.png'" alt="setting-icon"/>{{mls.languageText.create_posting.key16}}
          <img  [src]="'assets/images/right-arrow-icon.png'" alt="arrow-icon"/>
        </div>
      </div>
    </div>
  </div>

  <app-confirm-modal *ngIf="isConfirmModalShown==true" [isConfirmModalShown]="isConfirmModalShown"
    [confirmInfo]="confirmInfo" (resetConfirmModal)="resetConfirmModal($event)"></app-confirm-modal>

  <app-posting-media-modal *ngIf="is_show_post_media_modal==true" [is_show_post_media_modal]="is_show_post_media_modal"
    [is_show_post_media_modal_data]="is_show_post_media_modal_data"
    (resetPostMediaModal)="resetPostMediaModal($event)"></app-posting-media-modal>
  <app-canvas-image-editor *ngIf="dss.canvas_image_edit_obj?.is_show==true"
    [canvas_image_edit_obj]="dss.canvas_image_edit_obj"
    (saveUpdatedImage)="saveUpdatedImage($event)"></app-canvas-image-editor>


  <!--EOF Calling Media PopUp Component-->
  <app-media-modal *ngIf="mediaModal==true && openMediaIndex!=undefined" (resetMediaModal)=setResetMediaModal($event)
    [isMediaModalShown]="mediaModal" [mediaObj]="mediaObj" [openMediaIndex]=openMediaIndex></app-media-modal>

<div *ngIf="postPopup" class="modal fade" tabindex="-1" role="dialog" [config]="{ show: true, backdrop: 'static' }"
  bsModal #autoShownModal="bs-modal">
  <div class="custom-theme-modal modal-dialog modal-md modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-body pt-0">
        <div class="row">
          <div class="col-12 text-center mt-4">
            
            <p class="heading-4 mt-2 mb-2">
              {{mls.languageText.create_posting.key17}}  
            </p> 

          </div>
        </div>
      </div>
      <div class="modal-footer px-3 text-center pb-4 mx-auto">
        <button class="btn-design filled medium px-4" (click)="postPopClose()">
          {{mls.languageText.input_screen.key20}}
        </button>
      </div>
    </div>
  </div>
</div>

